'use client'
import { forwardRef, HTMLAttributes } from 'react'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import Link from 'next/link'
import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import ArrowUpRightIcon from '@/public/arrow-up-right.svg'
import style from './rich-text-highlight.module.scss'
import { Text } from '../text'

interface RichTextHighlightProps extends HTMLAttributes<HTMLDivElement> {
  text: string
  link: string | null
}

export const RichTextHighlight = forwardRef<HTMLDivElement, RichTextHighlightProps>((props, ref) => {
  const { className, text, link } = props
  const { ref: innerRef, animate } = useAppearance(ref)

  return (
    <motion.div
      ref={innerRef}
      animate={animate}
      variants={variantsHeadline}
      className={clsx(style.container, className, 'text text_color_dark richText')}
    >
      <Text className={style.text} type="t2" color="dark" __html={text ?? ''} />
      {!!link && (
        <Link href={link} className={style.link} target="_blank">
          <Text color="main-blue" type="t2" tagName="span">
            {link}
          </Text>
          <ArrowUpRightIcon className={style.svg} />
        </Link>
      )}
    </motion.div>
  )
})

RichTextHighlight.displayName = 'RichTextHighlight'
